import Modal from "react-responsive-modal";
import styles from "./styles.module.css";

type Props = {
  showFeedback: boolean;
  setFeedBack: (value: React.SetStateAction<boolean>) => void;
};

const ModalFeedBack = ({ showFeedback, setFeedBack }: Props) => {
  return (
    <Modal
      open={showFeedback}
      onClose={() => setFeedBack(false)}
      center
      classNames={{
        modal: styles.customModal,
      }}
    >
      <div className={styles.container}>
        <h2 className={styles.title}>Aviso</h2>
        <div className={styles.content}>
          <p>! Já existe uma conta relacionada a esse CPF</p>
        </div>
        <div>
          <button
            className={styles.exitBtn}
            onClick={() => {
              setFeedBack(false);
            }}
          >
            ✖ Fechar
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ModalFeedBack;
